// extracted by mini-css-extract-plugin
module.exports = {"weekCalendarContainer":"styles_weekCalendarContainer__AqK9_"};